import 'twin.macro';
import React from 'react';
import tw from 'twin.macro';
import { Background } from 'components/Background';
import Logo from 'assets/logo-black@2x.png';

interface TeetshBackgroundProps {
  children: React.ReactNode;
}

interface HeaderProps {
  children?: React.ReactNode;
  showLogo?: boolean;
  largeMobileLogo?: boolean;
}

interface ContentProps {
  children: React.ReactNode;
  className?: string;
}

interface FooterProps {
  children: React.ReactNode;
}

export function TeetshBackground({ children }: TeetshBackgroundProps) {
  return (
    <div>
      {/* BACKGROUND */}
      <div tw="fixed inset-0">
        <Background />
      </div>
      {/* CONTENT */}
      <div tw="relative h-screen flex flex-col items-center">{children}</div>
    </div>
  );
}

function Header({
  children,
  showLogo = true,
  largeMobileLogo = false,
}: HeaderProps) {
  return (
    <div tw="relative w-full px-6 py-4 flex items-center justify-center pt-10 pb-8 md:py-14 lg:py-16 [@media(max-height:800px)]:py-5">
      {showLogo && (
        <img
          css={[
            largeMobileLogo
              ? tw`h-[60px] lg:h-[80px] [@media(max-height:800px)]:h-[60px]`
              : tw`h-10 md:h-[60px] lg:h-[80px] [@media(max-height:800px)]:h-8 md:[@media(max-height:800px)]:h-[60px]`,
          ]}
          alt="Teetsh"
          src={Logo}
        />
      )}
      {children}
    </div>
  );
}

function Content({ children, className }: ContentProps) {
  return (
    <div
      tw="md:pb-12 lg:pb-16 md:[@media(max-height:800px)]:pb-8"
      className={className}
    >
      {children}
    </div>
  );
}

function Footer({ children }: FooterProps) {
  return <div tw="mt-auto pt-4 pb-8">{children}</div>;
}

// Attach sub-components
TeetshBackground.Header = Header;
TeetshBackground.Content = Content;
TeetshBackground.Footer = Footer;
